import {Button, Stack, Typography, Rating, FormControlLabel, Checkbox} from "@mui/material";
import {ProposalStatusPanel} from "../form/dropdown/ProposalStatusPanel";
import {ProposalStatus} from "../../types/Proposal";
import React, {useState} from "react";
import {ProposalFilter} from "../../service/proposal.service";
import {TextInput} from "../form/TextInput";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import {SourceDropdown} from "../form/dropdown/SourceDropdown";
import {MapDialog} from "../map/MapDialog";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import AddHomeWorkOutlinedIcon from '@mui/icons-material/AddHomeWorkOutlined';
import {Link} from "react-router";
import {useAuthStore} from "../../store/auth.store";
import {PremiumMessageElementProperties} from "./PremiumMessageElement";

interface ProposalFilterComponentProps {
    filter: ProposalFilter
    setFilter: (filter: ProposalFilter) => void
    hideFavorite?: boolean
    hideMy?: boolean
    small?: boolean
    hideAddNew?: boolean
    setShowPremiumMessageEl?: (showPremiumMessageEl:PremiumMessageElementProperties) => void
}

export function ProposalFilterComponent({hideAddNew, small, filter, setFilter, hideFavorite, hideMy, setShowPremiumMessageEl}:ProposalFilterComponentProps) {

    const [showMapFilter, setShowMapFilter] = useState(false);
    const { can, jwt } = useAuthStore();

    const canManage = can('manage_proposals');
    const fullAccess = can('full_access');

    function ratingClick(element: Element, inTable: boolean) {
        if (jwt) {
            setFilter({ ...filter, page: 0, favorite: !filter.favorite });
        } else {
            setShowPremiumMessageEl && setShowPremiumMessageEl({
                element: element,
                isOpen: true,
                isFavorite: !inTable,
                isFavoriteInTable: inTable,
                isPdf: false,
                isPhone: false,
                isMy: false,
                isSupport: false,
            });
        }
    }

    return <>
        <Stack sx={{flexDirection: small ? "column" : {xs: "column", lg: "row"}}} gap={"15px"} className={"mb-15"}>
            <Stack sx={{flexDirection: small ? "column" : {xs: "column", md: "row"}}}  gap={"15px"} className={"mb-15"}>
                <Stack gap={"15px"}>
                    <Stack flexDirection={"row"} gap={"10px"} justifyContent={'space-between'}>
                        <TextInput className={"flex-1"} label={"Price $ Min"} value={filter.priceMin} onChange={e => {
                            setFilter({ ...filter, page: 0, priceMin: filterInteger(e.target.value, filter.priceMin) })
                        }}/>
                        <TextInput className={"flex-1"} label={"Price $ Max"} value={filter.priceMax} onChange={e => {
                            setFilter({ ...filter, page: 0, priceMax: filterInteger(e.target.value, filter.priceMax) })
                        }}/>
                    </Stack>
                    <Stack flexDirection={"row"} gap={"10px"} justifyContent={'space-between'}>
                        <TextInput className={"flex-1"} label={"Price $/m² Min"} value={filter.pricePerMeterMin} onChange={e => {
                            setFilter({
                                ...filter,
                                page: 0,
                                pricePerMeterMin: filterInteger(e.target.value, filter.pricePerMeterMin)
                            })
                        }}/>
                        <TextInput className={"flex-1"} label={"Price $/m² Max"} value={filter.pricePerMeterMax} onChange={e => {
                            setFilter({
                                ...filter,
                                page: 0,
                                pricePerMeterMax: filterInteger(e.target.value, filter.pricePerMeterMax)
                            })
                        }}/>
                    </Stack>
                    <Stack flexDirection={"row"} gap={"10px"} justifyContent={'space-between'}>
                        <TextInput className={"flex-1"} label={"Area m² Min"} value={filter.areaMin} onChange={e => {
                            setFilter({ ...filter, page: 0, areaMin: filterInteger(e.target.value, filter.areaMin) })
                        }}/>
                        <TextInput className={"flex-1"} label={"Area m² Max"} value={filter.areaMax} onChange={e => {
                            setFilter({ ...filter, page: 0, areaMax: filterInteger(e.target.value, filter.areaMax) })
                        }}/>
                    </Stack>
                    <Button onClick={() => setShowMapFilter(true)} variant={filter.polygon && filter.polygon.length >= 3 ? "contained" : "outlined"}>
                        <TravelExploreIcon htmlColor={filter.polygon && filter.polygon.length >= 3 ? "white" : "gray"}/>&nbsp;Map
                    </Button>

                    {canManage &&
                        <TextInput label={"Phone"} value={filter.phone || ''} onChange={(e) => setFilter({
                            ...filter, page: 0, phone: e.target.value
                        })}/>}
                    {fullAccess &&
                        <SourceDropdown label={"Source"} value={filter.source || ''} onChange={(e) => setFilter({
                            ...filter, page: 0, source: e
                        })}/>}
                </Stack>
                <Stack gap={"15px"} sx={{minWidth: {md: '360px'}}}>
                    <TextInput label={"Proposal ID"} value={filter.id} onChange={e => {
                        setFilter({...filter, page: 0, id: e.target.value})}}/>

                    <TextInput label={"Address"} value={filter.address} onChange={e => {
                        setFilter({ ...filter, page: 0, address: e.target.value })
                    }}/>
                    {(!hideFavorite || (!hideMy && jwt)) && <Stack gap={"15px"} flexDirection={"row"} alignItems={"center"}>
                        {!hideFavorite && <Stack flexDirection={"row"} height={'56px'} alignItems={"center"}>
                            <Rating
                                value={jwt ? (filter.favorite ? 1 : 0) : 1}
                                precision={1}
                                size={'large'}
                                max={1}
                                onChange={(event) => {
                                    ratingClick(event.currentTarget, false)
                                }}
                                emptyIcon={<StarBorderOutlinedIcon style={{ opacity: 0.55 }} fontSize="inherit"/>}
                            />
                            <label className={"pointer"} onClick={e => ratingClick(e.currentTarget, false)}>Favorite</label>
                        </Stack>}

                        {!hideMy && <Stack flexDirection={"row"} alignItems={"center"}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={"my"}
                                        value={filter.my}
                                        required={false}
                                        size={"medium"}
                                        checked={filter.my}
                                        onChange={(e) => {
                                            if(jwt) {
                                                setFilter({...filter, page: 0, my: !filter.my})
                                            } else {
                                                setShowPremiumMessageEl && setShowPremiumMessageEl({
                                                    element: e.currentTarget,
                                                    isOpen: true,
                                                    isFavorite: false,
                                                    isFavoriteInTable: false,
                                                    isPdf: false,
                                                    isPhone: false,
                                                    isMy: true,
                                                    isSupport: false,
                                                })
                                            }
                                        }}
                                    />
                                }
                                label={"My"}
                            />
                        </Stack>}
                    </Stack>}
                    {!hideAddNew && <Button variant={"contained"} component={Link} to="/prop/new" startIcon={<AddHomeWorkOutlinedIcon/>}>
                        Add Listing
                    </Button>}

                    {canManage &&
                        <TextInput label={"Name"} value={filter.name || ''} onChange={(e) => setFilter({
                            ...filter, page: 0, name: e.target.value
                        })}/>}
                </Stack>
            </Stack>
            <Stack sx={{flexDirection:small ? "column" : {xs: "column", md: "row"}}}  gap={"15px"} className={"mb-15"}>
                <ProposalStatusPanel
                    value={filter.proposalStatuses}
                    includeHints
                    onChange={(value) => {
                        setFilter({
                            ...filter,
                            page: 0,
                            proposalStatuses: (value as ProposalStatus[])
                        })
                    }}/>
            </Stack>
        </Stack>
        {showMapFilter && <MapDialog
            maxWidth={900}
            polygon={filter.polygon}
            contentBefore={<Typography color={"primary"} className={"mb mb-15"}>Select at least 3 points to narrow search with your preferred location</Typography>}
            onPolygonChange={polygon => setFilter({...filter, page: 0, polygon})}
            onClose={(reason) => {
                if(reason !== 'apply_polygon') {
                    setFilter({ ...filter, page: 0, polygon: []});
                }
                setShowMapFilter(false)
            }}/>}

    </>
}


function filterInteger(value: string, defaultValue?: string) {
    if (!value) {
        return undefined;
    }
    const out = parseInt(value);
    if (isNaN(out) || !isFinite(out)) {
        return defaultValue;
    }
    return out.toString();
}